if (!customElements.get("make-custom-filters")) {
  customElements.define(
    "make-custom-filters",
    class MakeCustomFilters extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("#make-model-form");
        this.button = this.querySelector('button[type="submit"]');
        this.makeSelect = this.querySelector("#select-custom-filter-make");
        this.modelSelect = this.querySelector("#select-custom-filter-model");

        this.setupEventListeners();

        this.checkIfDefault();
      }

      checkIfDefault() {
        let selectedItem = this.makeSelect.options[this.makeSelect.selectedIndex];
        let selectedItemDefault = selectedItem.text == "" ? true : false;

        if (!selectedItemDefault) {
          createModelList(selectedItem.value, selectedItem.text);
          this.modelSelect.disabled = false;
        }
      }

      setupEventListeners() {
        this.form.addEventListener("submit", (event) => {
          event.preventDefault();
          window.location.href = this.form.getAttribute("action");
        });
        this.makeSelect.addEventListener("change", (event) => {
          event.preventDefault();
          this.onFilterSelect(event, "make");
        });
        this.modelSelect.addEventListener("change", (event) => {
          event.preventDefault();
          this.onFilterSelect(event, "model");
        });
      }

      onFilterSelect(event, type) {
        this.button.disabled = false;

        if (type == "make") {
          // Sends data to function in liquid to populate model select
          createModelList(event.target.value, this.makeSelect.options[this.makeSelect.selectedIndex].text);
          // Allows select to be used
          this.modelSelect.disabled = false;
          this.setFormUrl(event);
        }

        if (type == "model") {
          this.setFormUrl(event);
        }
      }

      setFormUrl(event) {
        let make = this.makeSelect.value;
        let model = this.modelSelect.value;

        // Sets action event on the form to the generated URL
        this.form.setAttribute("action", this.constructURL(make, model));
      }

      constructURL(make, model) {
        const url = new URL(window.requestShopUrl);
        let newUrl;

        if (make != '') {
          newUrl = `${url.href}pages/manufacturer/${make}`;
          if (model != '') {
            newUrl = `${url.href}pages/car-covers/${model}`;
          }
        }
        console.log(newUrl);
        return newUrl;
      }
    },
  );
}


